import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from 'src/global';
import { RootState } from 'src/store';
import { offersSelectors } from 'src/features/companyOffers/companyOffers.state';
import { CompanyOffer } from 'src/features/companyOffers/companyOffers.types';

export const useOffersState = (): RootState['companyOffers'] => {
  const offers = useSelector<RootState, RootState['companyOffers']>(state => state.companyOffers);

  useDebugValue(offers);

  return offers;
};

export const useOffersValues = (): CompanyOffer[] => {
  const offers = useSelector<RootState, RootState['companyOffers']>(state => state.companyOffers);

  const result = offersSelectors.selectAll(offers);

  useDebugValue(result);

  return result;
};

export const useOfferById = (code: string): AsyncEntity<CompanyOffer> | null => {
  const offers = useSelector<RootState, RootState['companyOffers']>(state => state.companyOffers);

  const result = offersSelectors.selectById(offers, code) || null;

  useDebugValue(result);

  return result;
};
